// extracted by mini-css-extract-plugin
module.exports = {"select":"_3rgPEn8wGatWLdjoGd9ZZ5"};